import { NgModule } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { ScreenWiperService } from '@app/services/screen-wiper.service';
import { UnitsService } from '@app/services/units.service';
import { BoardService } from '@main-application/boards/services/board.service';
import { DynamicInspectionService } from '@main-application/inspections/services/dynamic-inspection.service';
import { InspectionService } from '@main-application/inspections/services/inspection.service';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';
import { ModalsService } from '@ui-components/modals/modals.service';

@NgModule({
  declarations: [],
  providers: [
    OidcSecurityService,
    ModalsService,
    BoardService,
    InspectionService,
    DynamicInspectionService,
    SnackbarService,
    UnitsService,
    ScreenWiperService,
  ],
})
export class SingletonServicesModule {}
